export class HttpError extends Error {
	code = 400;
	options = {};

	constructor(code: number, options = {}, reason = "HTTP Error") {
		super(reason);

		this.code = code;
		this.options = {
			...this.options,
			...options,
		};
	}
}

export class NotFoundHttpError extends HttpError {
	constructor(reason: string, options = {}) {
		super(404, options, reason);
	}
}
